// src/App.js
import "./styles/App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";

import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";
import Book from "./pages/Book";
import Reviews from "./pages/Reveiws";
import GiftCards from "./pages/GiftCards";
import Services from "./pages/Services";
import Policy from "./pages/Policy";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import Jewelry from "./pages/PermanentJewelry";
import Gallery from "./pages/Gallery";
import ScrollToTop from "./components/ScrollToTop";

function AppContent() {
  const location = useLocation();

  const hideFooterPaths = ["/login", "/register", "/admin"];
  const shouldHideFooter = hideFooterPaths.some((path) =>
    location.pathname.startsWith(path)
  );

  useEffect(() => {
  // Prevent duplicate injection across reloads or hot refresh
  if (window.__ovatuBotLoaded) return;
  window.__ovatuBotLoaded = true;

  const loader = document.createElement("script");
  loader.type = "text/javascript";
  loader.async = true;

  loader.innerHTML = `
    !function(e,o,a){
      var t=a.queue||[];
      function n(){
        var s=o.createElement("script"),
            r=o.getElementsByTagName("script")[0];
        s.src="https://cdn.book.app/embed/v1.js";
        s.type="text/javascript";
        s.async=true;
        s.addEventListener("load",function(){
          for(;a.queue.length;) a.queue.shift()();
        },false);
        r.parentNode.insertBefore(s,r);
      }
      e.BookAppBotReady=a=function(fn){a.queue.push(fn)};
      a.queue=t;
      "complete"===o.readyState && n();
      window.addEventListener("load",n);
    }(window,document,window.BookAppBotReady||function(){});

    BookAppBotReady(function () {
      BookApp.bot('lashwithbrittany');
    });
  `;

  document.body.appendChild(loader);
  }, []);

  return (
    <div className="app-shell">
      <div className="app-card">
        <Navbar />
        <main className="app-main">
          <Routes location={location} key={location.key}>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<Book key={location.key} />} />
            <Route path="/giftcards" element={<GiftCards />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/pricelist" element={<Services />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact-me" element={<Contact />} />
            <Route path="/permanent-jewelry" element={<Jewelry />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </main>
        {!shouldHideFooter && <Footer />}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
